/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * When the Grand Prize drawing is triggered
 * @export
 */
export const GrandPrizeDrawTiming = {
    AFTER_SEGMENT: 'AFTER_SEGMENT',
    MANUAL: 'MANUAL'
} as const;
export type GrandPrizeDrawTiming = typeof GrandPrizeDrawTiming[keyof typeof GrandPrizeDrawTiming];


export function instanceOfGrandPrizeDrawTiming(value: any): boolean {
    for (const key in GrandPrizeDrawTiming) {
        if (Object.prototype.hasOwnProperty.call(GrandPrizeDrawTiming, key)) {
            if (GrandPrizeDrawTiming[key as keyof typeof GrandPrizeDrawTiming] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GrandPrizeDrawTimingFromJSON(json: any): GrandPrizeDrawTiming {
    return GrandPrizeDrawTimingFromJSONTyped(json, false);
}

export function GrandPrizeDrawTimingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrandPrizeDrawTiming {
    return json as GrandPrizeDrawTiming;
}

export function GrandPrizeDrawTimingToJSON(value?: GrandPrizeDrawTiming | null): any {
    return value as any;
}

export function GrandPrizeDrawTimingToJSONTyped(value: any, ignoreDiscriminator: boolean): GrandPrizeDrawTiming {
    return value as GrandPrizeDrawTiming;
}

